/* Copy for AI — one click packs the validator's verdict + the current
 * editor JSON into a refine prompt for the user's LLM chat (which
 * already holds the authoring guide from build step 0). Renders
 * wherever errors[]/warnings[] render. */
import React from 'react';
import {
    Sparkles
} from 'lucide-react';
import {
    notify
} from 'shared/api/notifier';

export function buildAiRefinePrompt(errors: string[], warnings: string[],
    docText: string): string {
    const head = errors.length > 0
        ? 'This JSON failed validation in the BeX system. Fix it per the '
            + 'authoring guide already in this chat. Return ONLY the '
            + 'corrected JSON.'
        : 'This JSON passed validation in the BeX system but drew advisory '
            + 'warnings. Improve it per the authoring guide already in this '
            + 'chat. Return ONLY the corrected JSON.';
    const parts = [head];
    if (errors.length > 0) {
        parts.push('ERRORS:\n' + errors.map((e) => `- ${e}`).join('\n'));
    }
    if (warnings.length > 0) {
        parts.push('WARNINGS (non-blocking):\n'
            + warnings.map((w) => `- ${w}`).join('\n'));
    }
    parts.push('CURRENT JSON:\n' + docText);
    return parts.join('\n\n');
}

export default function CopyForAiButton({
    errors,
    warnings,
    docText
}: {
    errors: string[];
    warnings: string[];
    docText: string;
}) {
    const copy = async () => {
        try {
            await navigator.clipboard.writeText(
                buildAiRefinePrompt(errors, warnings, docText));
            notify('Copied for AI — paste it into your LLM chat', 'success');
        } catch {
            notify('Clipboard unavailable — copy the errors manually', 'warning');
        }
    };
    return (
        <button
            className="aps-btn aps-btn-ghost aps-btn-sm"
            title="Copy a refine prompt (verdict + current JSON) for your LLM"
            onClick={copy}
        >
            <Sparkles size={13} />
            Copy for AI
        </button>
    );
}
